import { styled } from 'styled-components';

import { theme } from '../../styles';
import type { HeadingProps } from './root';
import { Headings } from './root';

const Heading = styled.h5<HeadingProps>`
  ${props => (props.styleAs ? theme.typography[props.styleAs] : theme.typography.h5)};
  ${Headings}
`;

export const H5 = ({
  style,
  testId,
  color = 'black90',
  marginTop,
  marginBottom,
  marginRight,
  marginLeft,
  styleAs,
  textAlign,
  fontStyle,
  children,
}: HeadingProps) => (
  <Heading
    style={style}
    data-testid={testId}
    color={color}
    marginTop={marginTop}
    marginBottom={marginBottom}
    marginRight={marginRight}
    marginLeft={marginLeft}
    styleAs={styleAs}
    textAlign={textAlign}
    fontStyle={fontStyle}
  >
    {children}
  </Heading>
);
